module.exports = __webpack_public_path__ + "static/media/a02.463ab520.gif";